import { c as _c } from "react/compiler-runtime";
import { isValidElement, cloneElement, Fragment, type JSX } from 'react';
import styled from 'styled-components';
import { colors } from '../../../../theme/colors';
import { ExpandableBody, ExpandableRow } from '../../../expandable-row';
import { Flexbox } from '../../../flexbox';
import { IconArrowDropDown } from '../../../icons';
import { LineClamp } from '../../../line-clamp';
import { Padding } from '../../../padding';
import { Text } from '../../../text';
import type { BaseCardProps } from '../../types';
import { INNER_PADDING } from '../../utils';
import { SelectableControl } from '../selectable-control';
export function CompactSizeDetailCard(props) {
  const $ = _c(56);
  const {
    actions,
    assistiveText,
    children,
    disabledProps,
    expanded,
    hasActions,
    isExpandable,
    isHighlighted,
    isSelectable,
    selectableOptions,
    setExpanded,
    showSubtitleComponentWhenExpanded,
    subtitle,
    testId,
    title,
    titleColor: t0
  } = props;
  const titleColor = t0 === undefined ? "black" : t0;
  let t1;
  if ($[0] !== disabledProps) {
    t1 = disabledProps ?? {};
    $[0] = disabledProps;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    isDisabled
  } = t1;
  let t2;
  if ($[2] !== setExpanded) {
    t2 = value => setExpanded(!value);
    $[2] = setExpanded;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== expanded || $[5] !== isExpandable || $[6] !== setExpanded || $[7] !== testId) {
    t3 = isExpandable && <StyledTitleChevron $isClickable={isExpandable} onClick={isExpandable && (() => setExpanded(!expanded))}><StyledArrowDiv className={expanded ? "expanded" : undefined}><IconArrowDropDown size={24} testId={`${testId}-expand-btn`} /></StyledArrowDiv></StyledTitleChevron>;
    $[4] = expanded;
    $[5] = isExpandable;
    $[6] = setExpanded;
    $[7] = testId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== expanded || $[10] !== isExpandable || $[11] !== setExpanded) {
    t4 = isExpandable ? () => setExpanded(!expanded) : undefined;
    $[9] = expanded;
    $[10] = isExpandable;
    $[11] = setExpanded;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = expanded ? 99 : 2;
  const t6 = isHighlighted ? colors.brand[400] : titleColor;
  const t7 = `${testId}-title`;
  let t8;
  if ($[13] !== t6 || $[14] !== t7 || $[15] !== title) {
    t8 = <Text weight={700} color={t6} testId={t7} breakword={true}>{title}</Text>;
    $[13] = t6;
    $[14] = t7;
    $[15] = title;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = <LineClamp numOfLines={t5}>{t8}</LineClamp>;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== isExpandable || $[21] !== t4 || $[22] !== t9) {
    t10 = <StyledTitleChevron $isClickable={isExpandable} onClick={t4}>{t9}</StyledTitleChevron>;
    $[20] = isExpandable;
    $[21] = t4;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== actions || $[25] !== hasActions || $[26] !== isDisabled || $[27] !== isSelectable || $[28] !== selectableOptions || $[29] !== title) {
    t11 = isSelectable ? <Flexbox alignItems="flex-start"><SelectableControl selectableOptions={selectableOptions} disabled={isDisabled} /></Flexbox> : <Flexbox gap={INNER_PADDING}>{hasActions && <>{actions?.map((action, i) => <Fragment key={`action-for-${title}-${i}`}>{isDisabled && isValidElement(action) ? cloneElement(action as JSX.Element, {
            disabled: isDisabled
          }) : action}</Fragment>)}</>}</Flexbox>;
    $[24] = actions;
    $[25] = hasActions;
    $[26] = isDisabled;
    $[27] = isSelectable;
    $[28] = selectableOptions;
    $[29] = title;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11) {
    t12 = <Flexbox justifyContent="space-between" gap={INNER_PADDING}>{t10}{t11}</Flexbox>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== expanded || $[35] !== showSubtitleComponentWhenExpanded || $[36] !== subtitle || $[37] !== testId) {
    t13 = subtitle && (!expanded || expanded && showSubtitleComponentWhenExpanded) && <LineClamp numOfLines={expanded ? 99 : 1}><Text color="light" testId={`${testId}-subtitle`} breakword={true}>{subtitle}</Text></LineClamp>;
    $[34] = expanded;
    $[35] = showSubtitleComponentWhenExpanded;
    $[36] = subtitle;
    $[37] = testId;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t12 || $[40] !== t13) {
    t14 = <Flexbox flex={1} flexDirection="column">{t12}{t13}</Flexbox>;
    $[39] = t12;
    $[40] = t13;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  let t15;
  if ($[42] !== t14 || $[43] !== t3) {
    t15 = <Flexbox alignItems="flex-start">{t3}{t14}</Flexbox>;
    $[42] = t14;
    $[43] = t3;
    $[44] = t15;
  } else {
    t15 = $[44];
  }
  let t16;
  if ($[45] !== assistiveText || $[46] !== testId) {
    t16 = assistiveText && <Padding top={INNER_PADDING}><Text color="light" size="small" testId={`${testId}-assistive-text`}>{assistiveText}</Text></Padding>;
    $[45] = assistiveText;
    $[46] = testId;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== children || $[49] !== t16) {
    t17 = <ExpandableBody paddingX={0} paddingBottom={0}><Padding size={INNER_PADDING}>{children}{t16}</Padding></ExpandableBody>;
    $[48] = children;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== expanded || $[52] !== t15 || $[53] !== t17 || $[54] !== t2) {
    t18 = <ExpandableRow removeStyling={true} expanded={expanded} onToggleRow={t2}>{t15}{t17}</ExpandableRow>;
    $[51] = expanded;
    $[52] = t15;
    $[53] = t17;
    $[54] = t2;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  return t18;
}
const StyledArrowDiv = styled.div`
  transition: transform 0.3s ease;
  border-radius: 50%;
  background: none;
  display: inline-block;

  &.expanded {
    transition: transform 0.3s ease;
    transform: rotate(180deg);
  }
`;
const StyledTitleChevron = styled.div<{
  $isClickable: boolean;
}>(({
  $isClickable
}) => `
  cursor: ${$isClickable ? 'pointer' : 'default'};
  `);